import ScrollableContainer from '../ScrollableContainer';

export const ScrollableContainerCommonProps = {
  onScrollAreaChanged: ScrollableContainer.propTypes['onScrollAreaChanged'],
  onScrollChanged: ScrollableContainer.propTypes['onScrollChanged'],
};
